<template>
  <el-dialog :title="title" :visible="visible" width="900px" :before-close="handleClose">
    <div class="coupon-list">
      <!-- <div
        :class="['coupon-item', id == item.id ? 'active-coupon-item' : '']"
        @click="chooseItem(item.id)"
        v-for="item in couponList"
        :key="item.id"
      >
        <div class="coupon-type">
          <span v-if="item.couponType == 0">现金券 Cash coupon</span>
          <span v-if="item.couponType == 1">折扣券 Discount Coupon</span>
        </div>
        <div class="coupon-price-content">
          <div class="coupon-price">
            <span class="price-symbol">{{ item.couponType == 0 ? "￥" : "" }}</span>
            <span>{{ item.couponValue }}</span>
            <span class="price-symbol">{{ item.couponType == 1 ? "折" : "" }}</span>
          </div>
          <div class="writeoff-condition">
            <span v-if="item.writeOffConditionSwitch == 1"> 满{{ item.writeOffConditionPrice }}可用 </span>
            <span v-else>无门槛</span>
          </div>
        </div>
        <div class="coupon-item-bottom">
          <div v-if="item.writeOffLimitType == 0">
            通用券
          </div>
          <div v-else-if="item.writeOffLimitType == 1">适用于{{ item.writeOffLimitCategoryName }}</div>
          <div v-else-if="item.writeOffLimitType == 2">适用于{{ item.writeOffLimitChannelName }}</div>
          <div v-else-if="item.writeOffLimitType == 3">
            适用于指定商品
          </div>
          <div v-else-if="item.writeOffLimitType == 4">
            适用于订房
          </div>
          <div v-else-if="item.writeOffLimitType == 5">
            适用于指定房型
          </div>
          <div class="mar-t-8">有效期: {{ item.validStartTime }}至{{ item.validEndTime }}</div>
        </div>
      </div> -->
      <CouponPanel
        @click.native="chooseItem(item.id)"
        v-for="item in couponList"
        :item="item"
        :id="id"
        :key="item.id"
      />
    </div>
    <div slot="footer">
      <el-button type="primary" @click="getCouponInstance">立即领取 Collect it immediately</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CouponPanel from "@/components/base/CouponPanel";
export default {
  props: {
    title: {
      type: String,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    couponList: {
      type: Array,
      default: () => [],
    },
  },
  components: { CouponPanel },
  data() {
    return {
      id: "",
    };
  },
  computed: {},
  methods: {
    handleClose(done) {
      this.$emit("update:visible", false);
      done();
    },
    async getCouponInstance() {
      const params = {
        couponId: this.id,
      };
      try {
        await this.$api.getCouponInstance(params);
        this.$message.success("领取成功");
        this.$emit("update:visible", false);
      } catch (error) {
        console.log(error);
      }
    },
    chooseItem(id) {
      this.id = id;
    },
  },
  watch: {
    couponList: {
      handler(val) {
        if (val instanceof Array && val.length) {
          this.id = val[0].id;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-list {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 22px;
  //margin-left: 55px;
  overflow-y: auto;
}
.expand-content {
  margin-top: 30px;
  span {
    display: inline-block;
    cursor: pointer;
    i {
      margin-left: 10px;
    }
    i.expand {
      background: url("~@/assets/img/more-icon.png") right center / 10px 10px no-repeat;
      transform: rotate(-180deg);
      width: 10px;
      height: 10px;
      display: inline-block;
    }
    i.shrink {
      background: url("~@/assets/img/more-icon.png") right center / 10px 10px no-repeat;
      transform: rotate(0);
      width: 10px;
      height: 10px;
      display: inline-block;
    }
  }
}
</style>
